import { useEffect } from 'react';

export default function useFooterBottomHeight() {
  useEffect(() => {
    const el = document.querySelector('.footer__bottom');
    if (!el) return;
    const root = document.documentElement;

    const sync = () => {
      const h = Math.ceil(el.getBoundingClientRect().height);
      root.style.setProperty('--footer-bottom-h', h + 'px');
    };

    sync();

    let ro;
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(sync);
      ro.observe(el);
    } else {
      window.addEventListener('resize', sync, { passive: true });
    }

    el.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', sync, { once: true });
    });

    if (document.fonts && typeof document.fonts.ready?.then === 'function') {
      document.fonts.ready.then(sync);
    }

    return () => {
      if (ro) ro.disconnect();
      window.removeEventListener('resize', sync);
    };
  });
}
